import { Injectable } from '@angular/core';
import { formatDate } from '@app/helpers/date.helper';
import { CertificateService } from '@app/services/certificates/certificate.service';
import { UserCertificate, UserSession } from '@app/store/models';
import { selectCertificate } from '@app/store/selectors/certificate.selector';
import { selectSession } from '@app/store/selectors/session.selector';
import { GlobalState } from '@app/store/store';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { LocalStorageService } from 'ngx-webstorage';
import { BehaviorSubject, Observable, combineLatest, tap } from 'rxjs';
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class UserService {
  userSession$: Observable<UserSession>;
  userCertificate$: Observable<UserCertificate>;

  constructor(
    private store: Store<GlobalState>,
    private certificateService: CertificateService,
    private localStorageService: LocalStorageService
  ) {
    this.userSession$ = this.store.select(selectSession);
    this.userCertificate$ = this.store.select(selectCertificate);

    setTimeout(() => {
      this.observeSigns();
      this.initCounters();
    }, 1000);
  }

  public $signsCounter = new BehaviorSubject({
    weeklySigns: 0,
    totalSigns: 0,
  });

  observeSigns() {
    this.store
      .select(selectSession)
      .pipe(
        untilDestroyed(this),
        tap(userSession => {
          let needActivation = [];
          if (this.localStorageService.retrieve('needActivation')) {
            if (
              this.localStorageService.retrieve('certificate')
                .certificateStatus === 'EMITTED'
            ) {
              let filteredNeedActivation = this.localStorageService
                .retrieve('needActivation')
                .filter(elem => elem !== this.certificateService.certID);
              this.localStorageService.store(
                'needActivation',
                filteredNeedActivation
              );
            }
            needActivation =
              this.localStorageService.retrieve('needActivation');
          }
        })
      )
      .subscribe();
  }

  initCounters() {
    combineLatest([this.userSession$, this.userCertificate$])
      .pipe(untilDestroyed(this))
      .subscribe(([userSession, certificate]) => {
        console.log('subscribe initCounters', { userSession, certificate });

        if (userSession?.automatic || userSession?.eseal) {
          this.$signsCounter.next({ weeklySigns: 0, totalSigns: 0 });
          return;
        }

        if (
          (userSession?.icssUser || userSession?.trissUser) &&
          certificate?.certId
        ) {
          Promise.all([this.getWeeklySigns(), this.getTotalSigns()]).then(
            values => {
              const [weeklySigns = 0, totalSigns = 0] = values;
              this.$signsCounter.next({ weeklySigns, totalSigns });
            }
          );
        }
      });
  }
  async getWeeklySigns(): Promise<number> {
    let startDate = formatDate(moment().subtract(7, 'days'));
    let endDate = formatDate(moment().add(1, 'days'));

    return this.certificateService
      .getActionReport(startDate, endDate)
      .then(response => {
        const weeklySigns = response?.length || 0;
        return weeklySigns;
      })
      .catch(error => {
        console.log(error);
        return 0;
      });
  }

  async getTotalSigns(): Promise<number> {
    let startDate = formatDate(moment().subtract(1, 'year'));
    let endDate = formatDate(moment().add(1, 'days'));

    return this.certificateService
      .getActionReport(startDate, endDate)
      .then(response => {
        const totalSigns = response?.length || 0;
        return totalSigns;
      })
      .catch(error => {
        console.log(error);
        return 0;
      });
  }
}
